<div
  *ngIf="visible"
  class="eva-dialog-container"
  [class.eva-dialog-container--centered]="centered && !fullscreen && !maximized"
  [class.eva-dialog-container--fullscreen]="fullscreen"
  [class.eva-dialog-container--maximized]="maximized && !fullscreen"
  [style.z-index]="currentZIndex"
>
  <!-- Backdrop -->
  <div class="eva-dialog__backdrop"></div>

  <!-- Dialog -->
  <div
    class="eva-dialog"
    [class.eva-dialog--confirm]="type === 'confirm'"
    [class.eva-dialog--alert]="type === 'alert'"
    [ngStyle]="dialogStyle"
    [ngClass]="styleClass"
    (click)="onContentClick($event)"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="header ? 'eva-dialog-title' : null"
  >
    <!-- Header -->
    <div *ngIf="header || closable || maximizable" class="eva-dialog__header">
      <div class="eva-dialog__header-content">
        @if (isNgIconName(headerIcon || typeIcon)) {
          <ng-icon
            class="eva-dialog__header-icon"
            [name]="headerIcon || typeIcon"
            [class.eva-dialog__header-icon--warning]="type === 'alert'"
            [class.eva-dialog__header-icon--info]="type === 'confirm'"
          />
        } @else if (headerIcon || typeIcon) {
          <i
            class="eva-dialog__header-icon"
            [ngClass]="headerIcon || typeIcon"
            [class.eva-dialog__header-icon--warning]="type === 'alert'"
            [class.eva-dialog__header-icon--info]="type === 'confirm'"
          ></i>
        }
        <h3 *ngIf="header" id="eva-dialog-title" class="eva-dialog__title">{{ header }}</h3>
        <!-- Slot optionnel pour injecter un tag ou un badge à côté du titre -->
        <ng-content select="[dialog-header-extra]"></ng-content>
      </div>
      <div class="eva-dialog__header-actions">
        <ng-content select="[dialog-header-actions]"></ng-content>
      </div>
      <button
        *ngIf="maximizable && !fullscreen"
        type="button"
        class="eva-dialog__close"
        (click)="toggleMaximize()"
        [attr.aria-label]="maximized ? 'Réduire' : 'Plein écran'"
      >
        <ng-icon [name]="maximized ? 'heroArrowsPointingIn' : 'heroArrowsPointingOut'"></ng-icon>
      </button>
      <button
        *ngIf="closable && type !== 'confirm' && type !== 'alert'"
        type="button"
        class="eva-dialog__close"
        (click)="requestHide()"
        aria-label="Fermer"
      >
        <ng-icon name="heroXMark"></ng-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="eva-dialog__content" [ngStyle]="contentStyle">
      <ng-content></ng-content>
    </div>

    <!--
      Footer (default or projected)
      IMPORTANT : le wrapper rend TOUJOURS la slot [dialog-footer]. Le CSS `:empty`
      (voir .scss) masque le wrapper si aucune projection n'est fournie.
      `showFooter=false` ne masque QUE les boutons par défaut — il n'annule pas
      un `<div dialog-footer>` fourni par le parent. Ne pas remettre `*ngIf` ici.
    -->
    <div class="eva-dialog__footer">
      <ng-content select="[dialog-footer]"></ng-content>

      <!-- Default footer buttons -->
      <div
        class="eva-dialog__footer-default"
        *ngIf="showFooter && (type === 'default' || type === 'confirm' || type === 'alert')"
      >
        <button type="button" class="eva-dialog__btn eva-dialog__btn--cancel" (click)="cancel()">
          {{ cancelLabel }}
        </button>
        <button
          type="button"
          class="eva-dialog__btn eva-dialog__btn--confirm"
          [class.eva-dialog__btn--primary]="confirmSeverity === 'primary'"
          [class.eva-dialog__btn--success]="confirmSeverity === 'success'"
          [class.eva-dialog__btn--warning]="confirmSeverity === 'warning'"
          [class.eva-dialog__btn--danger]="confirmSeverity === 'danger'"
          [class.eva-dialog__btn--loading]="confirmLoading"
          [disabled]="confirmDisabled || confirmLoading"
          (click)="confirm()"
        >
          <ng-icon name="evaSpinner" class="eva-icon-spin" *ngIf="confirmLoading"></ng-icon>
          <span>{{ confirmLabel }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
